import { selectFromVisitSubscription } from '../models';
import { SubscriptionHandler } from '../utils/createSubscription';
import visitGecodedHandler from './handlers/visitGecodedHandler';
import visitAddedHandler from './handlers/visitAddedHandler';
import visitDeletedHandler from './handlers/visitDeletedHandler';
import EditedVisitQuery from '../queries/visits/EditedVisitQuery';
import PendingVisitQuery from '../queries/visits/PendingVisitQuery';
import orderUpdatedHandler from './handlers/orderUpdatedHandler';


// here
const selector = selectFromVisitSubscription()
  .visitAddedDto(addedVisit => addedVisit.visit(v => v.id.name.deliveryDate.locations(loc =>
    loc.id.address.originalAddress.locationStatusId.latitude.longitude.bestMatch.active.coordinatesSource,
  )))
  .visitUnscheduledDto(unscheduledVisit => unscheduledVisit
    .visit(visit => visit.id.isScheduled.isScheduling.isUnscheduling.deliveryDate
      .locations(l => l.locationStatusId.latitude.longitude.bestMatch.active)
      .scheduledEvent(evnt => evnt
        .route(route => route
          .id
          .name
          .hexColor,
        )),
    ))
  .visitEditedDto(editedVisit => editedVisit.visit(EditedVisitQuery))
  .visitSchedulingDto(schedulingVisit => schedulingVisit.visit(visit => visit.id.isScheduled.isScheduling.isUnscheduling.pendingTargetRouteUuid
    .scheduledEvent(evnt => evnt.route(route => route.id.name.hexColor))))
  .visitSchedulingFailedDto(schedulingVisit => schedulingVisit.visit(visit => visit.id.isScheduled.isScheduling.isUnscheduling))
  .visitUnschedulingDto(unschedulingVisit => unschedulingVisit.visit(visit => visit.id.isScheduled.isScheduling.isUnscheduling.deliveryDate))
  .visitUnschedulingFailedDto(unschedulingVisit => unschedulingVisit.visit(PendingVisitQuery))
  .visitScheduledDto(scheduledVisit => scheduledVisit.visit(PendingVisitQuery))
  .visitDeletedDto(deletedVisit => deletedVisit.id.name)
  .orderDeliveryProgressDto(progress => progress.id.delivered.missed.orderUuid)
  .orderUnscheduledFromDeletedRouteDto(b => b.visit(v => v.id.uuid.isCompleted.isScheduled.deliveryDate
    .attempts(attempt => attempt.orderUuid.status).scheduledEvent(e => e.route(r => r.id.name))))
  .toString();

export default (): SubscriptionHandler => ({
  name: 'VisitSubscription',
  selector,
  events: new Map(Object.entries({
    VisitsGeocodedDto: [visitGecodedHandler],
    VisitAddedDto: [visitAddedHandler],
    VisitDeletedDto: [visitDeletedHandler],
    VisitEditedDto: [orderUpdatedHandler],
    OrderDeliveryProgressDto: [orderUpdatedHandler],
  })),
  onError(error: Error) {
    console.error('VisitSubscription Error, check if websocket client initialized', JSON.stringify(error));

  },
});
